import React from 'react'

import * as S from './styles'

import IProps from './props'

import convertDateStringToTime from '../../helpers/helper-covert-date-string'

const Message = ({ sendingDate, message, isReceived }: IProps) => (
  <S.Container isReceived={isReceived}>
    <S.Content isReceived={isReceived}>{message}</S.Content>
    <S.Hour>{convertDateStringToTime(sendingDate)}</S.Hour>
  </S.Container>
)

export default Message
